import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutScreenCodeTableLookup extends Layout {
    sourceScreenCodeTableInfo: DataSource;
    tableAliases: Table;
}
